// Registers the offline app-shell service worker (production builds only) and
// reports new versions to the app. See service-worker.js.
//
// Flow on a deploy: the browser finds the new service-worker.js, installs it
// in the background, and it waits. We fire 'sb:update-available'; the
// UpdatePrompt banner offers "Reload", which calls applyUpdate().

const UPDATE_EVENT = 'sb:update-available';
const CHECK_EVERY_MS = 60 * 60 * 1000; // also checked whenever the app is reopened

let waitingWorker = null;

function announce(worker) {
  waitingWorker = worker;
  window.dispatchEvent(new CustomEvent(UPDATE_EVENT));
}

// Whether a downloaded update is waiting (for components that mount late).
export const updateWaiting = () => !!waitingWorker;

// Switch to the waiting version, then reload once it has taken over.
export function applyUpdate() {
  if (!waitingWorker) { window.location.reload(); return; }
  let reloaded = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloaded) return;
    reloaded = true;
    window.location.reload();
  });
  waitingWorker.postMessage({ type: 'SKIP_WAITING' });
}

export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        // An update downloaded on an earlier visit is already waiting.
        if (registration.waiting && navigator.serviceWorker.controller) announce(registration.waiting);

        registration.addEventListener('updatefound', () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            // With no controller this is the first install, not an update.
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              announce(registration.waiting || installing);
            }
          });
        });

        // Phones keep the app open for days: look for new versions regularly
        // and whenever it comes back to the foreground.
        const check = () => { if (navigator.onLine) registration.update().catch(() => {}); };
        setInterval(check, CHECK_EVERY_MS);
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') check();
        });
      })
      .catch((error) => console.error('[SW] Registration failed:', error));
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((reg) => reg.unregister()).catch(console.error);
  }
}
